// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vu-0";
export var checkoutRateBadgeLink = "_vu-1";